import { IconComponent } from 'models/icons';

/**
 * This file was auto-generated using svgr
 *
 * Source file: assets/icons/list.svg
 */
const IconList: IconComponent = ({
  size = 24,
  color = 'white',
  className,
  svgElementProps: props = {},
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    color={color}
    className={className}
    {...props}
  >
    <path
      d="M1.03 18.559a1.03 1.03 0 100-2.061 1.03 1.03 0 000 2.061zM23.401 16.498H5.335a.599.599 0 00-.598.598v.864c0 .331.268.599.598.599h18.066c.331 0 .599-.268.599-.599v-.864a.599.599 0 00-.599-.598zM1.03 13.263a1.03 1.03 0 100-2.062 1.03 1.03 0 000 2.062zM23.401 11.201H5.335a.598.598 0 00-.598.599v.864c0 .33.268.599.598.599h18.066c.331 0 .599-.268.599-.599V11.8a.598.598 0 00-.599-.599zM1.03 7.502a1.03 1.03 0 100-2.06 1.03 1.03 0 000 2.06zM23.401 5.441H5.335a.599.599 0 00-.598.599v.864c0 .33.268.598.598.598h18.066c.331 0 .599-.268.599-.598V6.04a.599.599 0 00-.599-.599z"
      fill="currentColor"
    />
  </svg>
);

export default IconList;
